import { useCallback, useContext, useState } from 'react';
import { AppContext } from 'providers/AppProvider';
import { DetailsCardProps } from 'components';
import { DISABLED_STATUSES_EMPLOYEE, DISABLED_STATUSES_IPA } from 'consts';

export function useDetailsCard({ info, onClick }: DetailsCardProps) {
	const ctx = useContext(AppContext);
	const { config, fetchRelations, flowType, http, t } = ctx;
	const { API, API_DIGITAL_SIGNATURE_URL, IS_EMPLOYEE_WEB } = config;
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { kennitala, processInfo } = info;
	const { agreementProcessId, processStatus } = processInfo || {};
	const statuses: any = IS_EMPLOYEE_WEB ? DISABLED_STATUSES_EMPLOYEE : DISABLED_STATUSES_IPA;
	const btnLabel = t(statuses[processStatus], 'userboard');
	const onClickCancel = useCallback(() => setIsModalOpen(true), []);
	const onClose = useCallback(() => setIsModalOpen(false), []);

	const select = useCallback(() => {
		!info.disabledCard && onClick(kennitala);
	}, [kennitala, info.disabledCard, onClick]);

	const redirect = useCallback(() => {
		!info.disabledButton && (window.location.href = API_DIGITAL_SIGNATURE_URL);
	}, [API_DIGITAL_SIGNATURE_URL, info.disabledButton]);

	const onCancelProcess = useCallback(async () => {
		onClose();
		await http.delete(`${API.deleteProcess}/${agreementProcessId}`);
		await fetchRelations();
	}, [API.deleteProcess, agreementProcessId, http, fetchRelations, onClose]);

	return {
		...ctx,
		btnLabel,
		IS_EMPLOYEE_WEB,
		processStatus,
		isModalOpen,
		onClose,
		flowType,
		onCancelProcess,
		onClickCancel,
		redirect,
		select
	};
}
